import type { TFunction } from 'i18next';
import { ROLE } from '../constants';
import type { SidebarNavItem } from '../types/common';

const useSidebarNavItems = (t: TFunction<'translation', undefined>) => {
  const sidebarNavItems: SidebarNavItem[] = [
    // 共通
    // ========================================
    {
      title: '検索',
      items: [
        {
          role: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN],
          id: 'sidebarNavSearch',
          title: t('millSheet.search'),
          htmlBefore: '<i class="material-icons">search</i>',
          to: '/mill-sheet-search',
        },
      ],
    },
    {
      title: 'プロフィール',
      items: [
        {
          role: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
          id: 'sidebarNavUser',
          title: t('user.info'),
          htmlBefore: '<i class="material-icons">emoji_people</i>',
          to: '/user-info',
        },
        {
          role: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN],
          id: 'sidebarNavNews',
          title: t('information.news.news'),
          htmlBefore: '<i class="material-icons">info</i>',
          to: '/news',
        },
      ],
    },
    // マスタ編集
    // ========================================
    {
      title: 'マスタ編集',
      items: [
        {
          role: [ROLE.ADMIN],
          id: 'sidebarNavManageOrganization',
          title: t('organization.manage'),
          htmlBefore: '<i class="material-icons">corporate_fare</i>',
          to: '/manage-organization',
        },
        {
          role: [ROLE.POWERUSER, ROLE.ADMIN],
          id: 'sidebarNavManageCondition',
          title: t('condition.manage'),
          htmlBefore: '<i class="material-icons">visibility</i>',
          to: '/manage-condition',
        },
        {
          role: [ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
          id: 'sidebarNavManageUser',
          title: t('user.manage'),
          htmlBefore: '<i class="material-icons">person</i>',
          to: '/manage-user',
        },
        {
          role: [ROLE.ADMIN],
          id: 'sidebarNavManageApproval',
          title: t('approval.manage'),
          htmlBefore: '<i class="material-icons">checklist</i>',
          to: '/manage-approval',
        },
        {
          role: [ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
          id: 'sidebarNavManageDeliveryLocation',
          title: t('deliveryLocation.manage'),
          htmlBefore: '<i class="material-icons">edit_location_alt</i>',
          to: '/manage-delivery-location',
        },
        {
          role: [ROLE.MAINTENANCE_ADMIN],
          id: 'sidebarNavManageOrganizationBase',
          title: t('organizationBase.manage'),
          htmlBefore: '<i class="material-icons">corporate_fare</i>',
          to: '/manage-organization-base',
        },
        {
          role: [ROLE.MAINTENANCE_ADMIN],
          id: 'sidebarNavManageInformation',
          title: t('information.login.manage'),
          htmlBefore: '<i class="material-icons">info</i>',
          to: '/manage-information',
        },
        {
          role: [ROLE.ADMIN],
          id: 'sidebarNavManageNews',
          title: t('information.manage'),
          htmlBefore: '<i class="material-icons">info</i>',
          to: '/manage-news',
        },
      ],
    },
    // ユーザ棚卸管理
    // ========================================
    {
      title: 'ユーザ棚卸管理',
      items: [
        {
          role: [ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
          id: 'sidebarNavInventoryJob',
          title: t('inventory.job'),
          htmlBefore: '<i class="material-icons">add_task</i>',
          to: '/inventory-job',
        },
        {
          role: [ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
          id: 'sidebarNavInventoryStatus',
          title: t('inventory.status'),
          htmlBefore: '<i class="material-icons">task</i>',
          to: '/inventory-status',
        },
      ],
    },
    // ヘルプセンター
    // ========================================
    {
      title: 'ヘルプセンター',
      items: [
        {
          role: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
          id: 'sidebarNavDownload',
          title: t('helpCenter.download.title'),
          htmlBefore: '<i class="material-icons">file_copy</i>',
          to: '/download',
        },
        {
          role: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
          id: 'sidebarNavQa',
          title: t('helpCenter.qa.title'),
          htmlBefore: '<i class="material-icons">question_answer</i>',
          to: '/qa',
        },
      ],
    },
  ];
  return sidebarNavItems;
};

export default useSidebarNavItems;
